import React from 'react';
import $ from 'jquery';
import { CONF_VPAID } from '../../../../constants/Labels';
import { parseToFloat } from '../../../../helpers/tools';
class VpaidSettings extends React.Component {
  constructor(props) {
    super(props);
    this.section = 'vpaid';
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.invalidFileds = [];
  }

  componentDidMount() {
    this.toggleBlurListeners(true);
  }

  componentWillUnmount() {
    this.toggleBlurListeners(false);
  }
  /** Used for import settings, to display on active tab errors */
  componentDidUpdate() {
    this.toggleBlurListeners(false);
    this.toggleBlurListeners(true);
  }

  toggleBlurListeners = addListeners => {
    if (addListeners) {
      $('#' + this.section)
        .find('input[name="totalTimeout"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', true, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="loadTimeout"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', true, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="initTimeout"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', true, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="generalTimeout"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', true, this);
          }).bind(this)
        );
    } else {
      $('#' + this.section)
        .find('input[name="totalTimeout"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="loadTimeout"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="initTimeout"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="generalTimeout"]')
        .off('blur');
    }
  };

  render() {
    return (
      <div className="pluginSettingsSection" id={this.section}>
        <div
          className="placementDescription"
          onClick={e => this.props.toggleElement(e, '.settingsInputs')}
        >
          <div className="pluginSectionsTitle vpaidTitle">VPAID Settings</div>
        </div>
        <div className="settingsInputs">
          <div
            className="settingsDescription description"
            dangerouslySetInnerHTML={{ __html: CONF_VPAID }}
          ></div>
          <div className="inputsRow">
            <div className="bigInput">
              <label>Total timeout</label>
              <input
                type="text"
                name="totalTimeout"
                key={this.props.vpaid.totalTimeout}
                className="textFiled"
                defaultValue={this.props.vpaid.totalTimeout}
                min="0"
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>Enable countdown video</label>
              </div>
              <div className="smallInput">
                <label>Enable skip</label>
              </div>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.vpaid.enableCountdownVideo}
                  name="enableCountdownVideo_vpaid"
                  id="enableCountdownVidoeVpaid0"
                  defaultValue={true}
                  defaultChecked={this.props.vpaid.enableCountdownVideo === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableCountdownVidoeVpaid0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.vpaid.enableCountdownVideo}
                  name="enableCountdownVideo_vpaid"
                  id="enableCountdownVideoVpaid1"
                  defaultValue={false}
                  defaultChecked={this.props.vpaid.enableCountdownVideo === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableCountdownVideoVpaid1">False</label>
              </p>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.vpaid.enableSkip}
                  name="enableSkip"
                  id="enableSkip0"
                  defaultValue={true}
                  defaultChecked={this.props.vpaid.enableSkip === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableSkip0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.vpaid.enableSkip}
                  name="enableSkip"
                  id="enableSkip1"
                  defaultValue={false}
                  defaultChecked={this.props.vpaid.enableSkip === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableSkip1">False</label>
              </p>
            </div>
          </div>
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>Enable skip label</label>
              </div>
              <div className="smallInput">
                <label>Handle skip offset</label>
              </div>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.vpaid.enableSkipLabel}
                  name="enableSkipLabel"
                  id="enableSkipLabelVpaid0"
                  defaultValue={true}
                  defaultChecked={this.props.vpaid.enableSkipLabel === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableSkipLabelVpaid0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.vpaid.enableSkipLabel}
                  name="enableSkipLabel"
                  id="enableSkipLabelVpaid1"
                  defaultValue={false}
                  defaultChecked={this.props.vpaid.enableSkipLabel === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableSkipLabelVpaid1">False</label>
              </p>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.vpaid.handleSkipOffset}
                  name="handleSkipOffset"
                  id="handleSkipOffset0"
                  defaultValue={true}
                  defaultChecked={this.props.vpaid.handleSkipOffset === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="handleSkipOffset0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.vpaid.handleSkipOffset}
                  name="handleSkipOffset"
                  id="handleSkipOffset1"
                  defaultValue={false}
                  defaultChecked={this.props.vpaid.handleSkipOffset === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="handleSkipOffset1">False</label>
              </p>
            </div>
          </div>
          <div className="more">
            <div className="inputsRow">
              <div className="labelHolder">
                <div className="smallInput">
                  <label>Load timeout</label>
                </div>
                <div className="smallInput">
                  <label>Init timeout</label>
                </div>
              </div>
              <div className="smallInput">
                <input
                  type="text"
                  name="loadTimeout"
                  key={this.props.vpaid.loadTimeout}
                  className="textFiled"
                  defaultValue={this.props.vpaid.loadTimeout}
                  min="0"
                />
                <div className="validationError"></div>
              </div>
              <div className="smallInput">
                <input
                  type="text"
                  name="initTimeout"
                  key={this.props.vpaid.initTimeout}
                  className="textFiled"
                  defaultValue={this.props.vpaid.initTimeout}
                  min="0"
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <label>General timeout</label>
                <input
                  type="text"
                  name="generalTimeout"
                  key={this.props.vpaid.generalTimeout}
                  className="textFiled"
                  defaultValue={this.props.vpaid.generalTimeout}
                  min="0"
                />
                <div className="validationError"></div>
              </div>
            </div>
          </div>
          <div className="moreButtonWrapper">
            <a className="moreButton" onClick={e => this.props.toggleElement(e, '.more')}>
              Show more options <span>▼</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default VpaidSettings;
